import { Link } from 'react-router-dom'
import { SecurityHead } from '@/securities/securityHead'
import { APP_ROUTES } from '@/common/constants'
import { NAVIGATION_COPY } from '@/locales/en'
import { InstrumentSearchRecordT } from '@/common/types'
import { SearchResultsState } from './SearchResultsState'

type Props = {
    searching: boolean
    searchResult: InstrumentSearchRecordT[]
    onResultClick: (security: InstrumentSearchRecordT) => void
}

export function DesktopSearchResults({ searching, searchResult, onResultClick }: Props) {
    return (
        <SearchResultsState
            searching={searching}
            items={searchResult}
            emptyMessage={NAVIGATION_COPY.instrumentSearch.noResults}
        >
            {(items) => (
                <div className="w-full">
                    {items.map((instrument) => (
                        <Link
                            key={instrument.securityCode}
                            to={`${APP_ROUTES.SECURITY}/${instrument.securityCode}`}
                            className="text-inherit"
                            onClick={() => onResultClick(instrument)}
                        >
                            <SecurityHead security={instrument} className="w-full px-2 hover:bg-lime-50" />
                        </Link>
                    ))}
                </div>
            )}
        </SearchResultsState>
    )
}
